<template>
  <span class="vid-icon text-center d-none d-lg-inline-block">
    <img
      v-if="showIcon"
      :src="iconSrc"
      @click.stop="openVideo"
      alt="Play icon"
      class="w-10 h-10 transition-transform duration-300 hover:scale-110 cursor-pointer"
    />
  </span>
</template>

<script>
import { bus } from "@/bus";

export default {
  name: "VideoHoverPlayer",
  props: {
    videoUrl: {
      type: String,
      required: true,
      description: "Full Vimeo video URL or video ID",
    },
    title: {
      type: String,
      required: true,
      description: "Video title",
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: true
    },
    iconSrc: {
      type: String,
      default: () => require("@/assets/icons/play-icon.svg"),
    },
  },
  methods: {
    openVideo() {
      // Emit event to open global video modal
      bus.$emit('open-video-modal', {
        videoUrl: this.videoUrl,
        title: this.title
      });
    }
  }
};
</script>

<style scoped>
.vid-icon {
  position: relative;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  margin-left: 6px;
  flex-shrink: 0;
}

.vid-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media (max-width: 768px) {
  .vid-icon {
    display: none !important;
  }
}
</style>
